import './styles.css';
import React, { memo } from 'react';
import { Result } from 'antd';
import { t } from 'i18next';

/**
 * アプリ設定タイムアウトエラー表示の実装
 */
const TimeoutPage = memo(() => {
    return (
        <div style={{ display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
            <Result status="warning" title="Timeout" subTitle={t('error-message.server-error')} />
        </div>
    );
});

export default TimeoutPage;
